module.exports = __webpack_public_path__ + "static/media/voucher_b.578f27fe.svg";